import React from 'react'
import moment from "moment"

import { FormControlLabel, InputLabel, Grid, Button, Checkbox, FormHelperText } from '@material-ui/core';
import { makeStyles } from "@material-ui/core"
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { parseISO } from 'date-fns';
import { useHistory,} from "react-router-dom";

import { ChipSelect } from "dsilo-ui-components";

const useStyles = makeStyles((theme) => {
  const isNewV1Theme = theme?.isNewV1Theme || false;

  return {
    paper: {
    },
    gridContainer:{
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
        
    },
    containerDiv:{
      width: '100% !important', 
      padding: '10px', 
      margin : '0px !important',
    },
    InputLabel: {
        marginTop: 20
    },
    TextField: {
        width: '100%',
        '& .MuiInputBase-formControl': {
            height: '43px !important'
        }
    },
    chipSelect: {
        ...(isNewV1Theme ? { '& input': {
        },
        } : {}),
    ...(isNewV1Theme 
    ? {
      '& div[class^="ChipSelect-valueContainer"]': {
            padding: '8px !important',  
        },   
        } 
        : {}),   
    ...(isNewV1Theme 
        ? { 
        '& .MuiChip-root': { 
            backgroundColor: '#fff !important',
            border: '1px solid #D5D6DD !important', 
        },   
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D6DD !important',  
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#303F9F !important',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3F51B5 !important',
        },
        } 
        : {}),   
    },
    textField: {
            width: '100%',
          '& .MuiOutlinedInput-input': {
          padding: '8px !important',
          fontSize: '12px',
          },
          '& .MuiOutlinedInput-input:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 1000px #fff inset !important',
          },
          '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#D5D6DD !important',  
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#303F9F !important',
          },

          '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#3F51B5 !important',
          },
    },
    lables:{
        color: '#78798E',
        fontSize: '12px',
        lineHeight: '17px',
        marginBottom:6
    },
    update:{
        borderRadius: "4px",
        border: "1px solid #3F51B5",
        background: "#3F51B5",
        color: '#fff',
        textTransform: 'capitalize',
        height: '30px',
        boxSizing: 'border-box',
        boxShadow: 'none',
        "&:hover": {
            background: "#303F9F",
            color: "#fff",
            boxShadow: 'none',
        },
    },
    cancel:{
       borderRadius: "4px", 
       border: "1px solid #3F51B5",
       color: '#3F51B5',
       background: "#fff",
       textTransform: 'capitalize',
       height: '30px',
       boxSizing: 'border-box',
       boxShadow: 'none',
       "&:hover": {
        boxShadow: 'none',       
       },
    },
    buttonContainer:{
      borderTop: '1px solid #E0E0E0', 
      padding: 10,
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      gap: 10
    },
    status: {
        display: 'contents'
    },
    error: {
        marginLeft: 14,
        color: 'red',
    },
    noMargin:{
    '& .MuiFormControl-marginNormal': {
      marginTop: '0 !important',
      marginBottom: '0 !important',
    },
    
    },
  datePicker: {
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    width: '100%',
    '& .MuiInputBase-input': {
    padding: '6px 8px 7px !important',
    fontSize: '12px',
    height: '32px !important',
    boxSizing: 'border-box',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
  },
    
}});

const BasicInfo = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { isNewV1Theme } = props;
    let delegation = props.appConfiguration?.system?.delegations
    let hideDelegate = delegation?.hideDelegate || false

    const handleBackBtnClick = () => {
    history.goBack()
    }

    return (
    <Grid style={{width: '100%', height:'calc(100vh - 200px)', overflow:'auto'}}>
    {!isNewV1Theme ? (
        <Grid container xs={6} spacing={3} >
            <Grid item xs={3} sm={3}>
                <InputLabel htmlFor="my-input" className={classes.InputLabel}>User</InputLabel>
            </Grid>
            <Grid item xs={9} sm={9}>
                <ChipSelect
                    value={props.delegationData.user}
                    isSearchable={true}
                    name={'user'}
                    className={classes.chipSelect}
                    textFieldProps={{
                        InputLabelProps: {
                            shrink: true,
                        },
                        variant: 'outlined',
                    }}
                    variant="fixed"
                    options={props.memberList}
                    onChange={(e) => props.basicInfoOnFormChange('user', e)}
                />
                {props.validationError.user && <FormHelperText className={classes.error}>{'Please select a User'}</FormHelperText>}
            </Grid>
            {!hideDelegate && <><Grid item xs={3} sm={3}>
                <InputLabel htmlFor="my-input" className={classes.InputLabel}>Delegate</InputLabel>
            </Grid>
            <Grid item xs={9} sm={9}>
                <ChipSelect
                    value={props.delegationData.delegate}
                    isSearchable={true}
                    name={'delegate'}
                    className={classes.chipSelect}
                    textFieldProps={{
                        InputLabelProps: {
                            shrink: true,
                        },
                        variant: 'outlined',
                    }}
                    variant="fixed"
                    options={props.delegateMemberList}
                    onChange={(e) => props.basicInfoOnFormChange('delegate', e)}
                />
                {props.validationError.delegate && <FormHelperText className={classes.error}>{'Please select a Delegate'}</FormHelperText>}
            </Grid></>}
            <Grid item xs={3} sm={3}>
                <InputLabel htmlFor="my-input" className={classes.InputLabel}>From</InputLabel>
            </Grid>
            <Grid item xs={9} sm={9}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        margin="normal"
                        format="yyyy-MM-dd"
                        name='from'
                        // value={props.delegationData.from}
                        value={parseISO(props.delegationData.from)}
                        onChange={(date) => { props.basicInfoOnFormChange('from', date) }}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>
                {props.validationError.from && <FormHelperText className={classes.error}>{'Please select a Valid date'}</FormHelperText>}
            </Grid>
            <Grid item xs={3} sm={3}>
                <InputLabel htmlFor="my-input" className={classes.InputLabel}>To</InputLabel>
            </Grid>
            <Grid item xs={9} sm={9}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        margin="normal"
                        format="yyyy-MM-dd"
                        name='to'
                        // value={props.delegationData.to}
                        value={parseISO(props.delegationData.to)}
                        minDate={props.delegationData.from}
                        onChange={(date) => { props.basicInfoOnFormChange('to', date) }}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>
                {props.validationError.to && <FormHelperText className={classes.error}>{'Please select a Valid date'}</FormHelperText>}
            </Grid>
            {!hideDelegate && <Grid item xs={12} sm={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={props.delegationData.assignPendingTasks}
                            onChange={(e) => { props.basicInfoOnFormChange('assignPendingTasks', e.target.checked) }}
                            style={{
                                transform: "scale(1)", paddingRight: 20, marginLeft: 5,
                            }}
                            color="primary"
                            name={'assignPendingTasks'}
                        />}
                    label={'Assign pending tasks'}
                />
            </Grid>}
            <Grid item xs={12} sm={12}>
                <Button style={{ float: 'right' }} variant="contained" color="primary" onClick={props.basicInfoOnSubmit}>{props.delegationData?._id ? "Update" : "Save"}</Button>
            </Grid>
        </Grid>
        ) : (
            <div className={classes.gridContainer}>
                <Grid container spacing={2} className={classes.containerDiv}>
                {/* Row 1 */}
                    <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor="my-input" className={classes.lables}>User</InputLabel>
                    <ChipSelect
                        value={props.delegationData.user}
                        isSearchable={true}
                        name={'user'}
                        className={classes.chipSelect}
                        textFieldProps={{
                            InputLabelProps: {
                                shrink: true,
                            },
                            variant: 'outlined',
                        }}
                        variant="fixed"
                        options={props.memberList}
                        onChange={(e) => props.basicInfoOnFormChange('user', e)}
                    />
                    {props.validationError.user && <FormHelperText className={classes.error}>{'Please select a User'}</FormHelperText>}
                    </Grid>
                    {!hideDelegate && <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor="my-input" className={classes.lables}>Delegate</InputLabel>
                        <ChipSelect
                            value={props.delegationData.delegate}
                            isSearchable={true}
                            name={'delegate'}
                            className={classes.chipSelect}
                            textFieldProps={{
                                InputLabelProps: {
                                    shrink: true,
                                },
                                variant: 'outlined',
                            }}
                            variant="fixed"
                            options={props.delegateMemberList}
                            onChange={(e) => props.basicInfoOnFormChange('delegate', e)}
                        />
                        {props.validationError.delegate && <FormHelperText className={classes.error}>{'Please select a Delegate'}</FormHelperText>}
                    </Grid>}
                    <Grid item xs={12} sm={6}>
                        <div className={classes.noMargin}>
                            <InputLabel htmlFor="my-input" className={classes.lables}>From</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    format="yyyy-MM-dd"
                                    name='from'
                                    // value={props.delegationData.from}
                                    value={parseISO(props.delegationData.from)}
                                    onChange={(date) => { props.basicInfoOnFormChange('from', date) }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    TextFieldProps={{
                                    variant: 'standard', 
                                    }}
                                    className={classes.datePicker}
                                />
                            </MuiPickersUtilsProvider>
                            {props.validationError.from && <FormHelperText className={classes.error}>{'Please select a Valid date'}</FormHelperText>}
                         </div>
                    </Grid>
        
                    <Grid item xs={12} sm={6}>
                        <div className={classes.noMargin}>
                            <InputLabel htmlFor="my-input" className={classes.lables}>To</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    format="yyyy-MM-dd"
                                    name='to'
                                    // value={props.delegationData.to}
                                    value={parseISO(props.delegationData.to)}
                                    minDate={props.delegationData.from}
                                    onChange={(date) => { props.basicInfoOnFormChange('to', date) }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    TextFieldProps={{
                                    variant: 'standard', 
                                    }}
                                    className={classes.datePicker}
                                />
                            </MuiPickersUtilsProvider>
                            {props.validationError.to && <FormHelperText className={classes.error}>{'Please select a Valid date'}</FormHelperText>}
                        </div>
                    </Grid>
                    {!hideDelegate && <Grid item xs={12} sm={6}>
                            <FormControlLabel
                            control={
                            <Checkbox
                                checked={props.delegationData.assignPendingTasks}
                                onChange={(e) => { props.basicInfoOnFormChange('assignPendingTasks', e.target.checked) }}
                                style={{
                                    transform: "scale(1)", paddingRight: 20, marginLeft: 5,
                                }}
                                color="primary"
                                name={'assignPendingTasks'}
                            />}
                            label={'Assign pending tasks'}
                            />
                    </Grid>}
                 </Grid>
                {/* Buttons */}
                <Grid item  xs={12} className={classes.buttonContainer}>
                    <Button
                        variant="contained"
                        onClick={handleBackBtnClick}
                        className={classes.cancel}
                    >
                        {"Close"}
                    </Button>
                    <Button  
                        variant="contained" 
                        className={classes.update}
                        onClick={props.basicInfoOnSubmit}>
                        {!props.delegationData?._id ? "Update" : "Save"}
                    </Button>
                
                </Grid>
            </div>
            )} 
    </Grid>  
    )
}

export default BasicInfo